import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: ()=> import('@/routerViews/ViewPC'),
    children: [
      {
        path: '/',
        name:'Index',
        component: ()=>import('@/views/Index'),
        meta:{
          title: '首页'
        }
      },
      {
        path: 'about',
        name:'About',
        component: ()=>import('@/views/About'),
        meta:{
          title: '关于大赛'
        }
      },
      {
        path: 'contactus',
        name:'ContactUs',
        component: ()=>import('@/views/ContactUs'),
        meta:{
          title: '联系我们'
        }
      },
      {
        path: 'certificate',
        name:'Certificate',
        component: ()=>import('@/views/Certificate'),
        meta:{
          title: '证书查询'
        }
      },
      {
        path: 'committee',
        name:'Committee',
        component: ()=>import('@/views/Committee'),
        meta:{
          title: '委员会'
        }
      },
      {
        path: 'news/list',
        name:'newsList',
        component: ()=>import('@/views/news/list'),
        meta:{
          title: '新闻动态'
        }
      },
      {
        path: 'news/detail',
        name:'newsDetail',
        component: () => import('@/views/news/detail'),
        meta:{
          title: '新闻详情'
        }
      },
      {
        path: 'user/account/login',
        name:'userLogin',
        component: () => import('@/views/user/login'),
        meta:{
          title: '登录'
        }
      },
      {
        path: 'user/account/rest',
        name:'rest',
        component: () => import('@/views/user/rest'),
        meta:{
          title: '找回密码'
        }
      },
      {
        path: 'user/account/register_success',
        name:'register_success',
        component: () => import('@/views/user/register_success'),
        meta:{
          title: '注册成功'
        }
      },
      {
        path: 'user/account',
        name:'userAccountManage',
        component: () => import('@/views/user/account'),
        meta:{
          title: '账号管理'
        }
      },
      {
        path: 'user/certificate',
        name:'userCertificate',
        component: () => import('@/views/user/certificate'),
        meta:{
          title: '账号管理'
        }
      },
      {
        path: 'user/account/register',
        name: 'userRegister',
        component: () => import('@/views/user/identity'),
        props:{
          curType: 'register'
        },
        meta:{
          title: '注册',
        }
      },
      {
        path: 'user/works',
        name:'userWorks',
        component: () => import('@/views/user/works'),
        meta:{
          title: '个人主页',
          needAuth: true
        }
      },
      {
        path: 'user/works/edit',
        name:'userWorksEdit',
        component: () => import('@/views/user/works_edit'),
        meta:{
          title: '作品编辑',
          needAuth: true
        }
      },
      {
        path: 'user/works/info',
        name:'userWorksInfo',
        component: () => import('@/views/user/works_info'),
        meta:{
          title: '作品查看',
          needAuth: true
        }
      },
      {
        path: 'user/index',
        name:'userHome',
        component: () => import('@/views/user/index'),
        meta:{
          title: '个人主页',
          needAuth: true
        }
      },
      {
        path: 'user/design',
        name:'userDesign',
        component: () => import('@/views/user/identity'),
        props:{
          curType: 'design'
        },
        meta:{
          title: '立即参赛',
          needAuth: true
        }
      },
      {
        path: 'user/register/index',
        name: 'userRegisterIndex',
        component: () => import('@/views/user/register'),
        props:{
          curType: 'register'
        },
        meta:{
          title: '注册',
        }
      },
      {
        path: 'rule/normal',
        name: 'rule_normal',
        component: () => import('@/views/rule/normal'),
        meta:{
          title: '校园赛道'
        }
      },
      {
        path: 'rule/special',
        name: 'rule_special',
        component: () => import('@/views/rule/special'),
        meta:{
          title: '专项课题赛事'
        }
      },
      {
        path: 'rule/special/info',
        name: 'rule_special_info',
        component: () => import('@/views/rule/special_info'),
        meta:{
          title: '专项课题赛事详情'
        }
      },
      {
        path: 'rule/special/subject',
        name: 'rule_special_subject',
        component: () => import('@/views/rule/special_subject'),
        meta:{
          title: '赛事详情'
        }
      },
      {
        path: 'rule/jointly',
        name: 'rule_jointly',
        component: () => import('@/views/rule/jointly'),
        meta:{
          title: '区域（省）品牌包装设计征集大赛'
        }
      },
      {
        path: 'rule/mascot',
        name: 'rule_mascot',
        component: () => import('@/views/rule/mascot'),
        meta:{
          title: '中国品牌日吉祥物征集大赛'
        }
      },
      {
        path: 'rule/enterprise',
        name: 'rule_enterprise',
        component: () => import('@/views/rule/enterprise'),
        meta:{
          title: '社会赛道'
        }
      },
      {
        path: 'search',
        name: 'search',
        component: () => import('@/views/Search'),
        meta:{
          title: '搜索结果'
        }
      },
      {
        path: 'flow/step1',
        name: 'flowStep1',
        component: () => import('@/views/flow/step1'),
        meta:{
          title: '信息填写',
          needAuth: true
        }
      },
      {
        path: 'flow/step2',
        name: 'flowStep2',
        component: () => import('@/views/flow/step2'),
        meta:{
          title: '上传作品',
          needAuth: true
        }
      },
      {
        path: 'flow/step3',
        name: 'flowStep3',
        component: () => import('@/views/flow/step3'),
        meta:{
          title: '上传完成',
          needAuth: true
        }
      },
      {
        path: 'works',
        name: 'works',
        component: () => import('@/views/works/list'),
        meta:{
          title: '获奖作品'
        }
      },
      {
        path: 'works/detail',
        name: 'worksDetail',
        component: () => import('@/views/works/detail'),
        meta:{
          title: '作品详情'
        }
      },
      {
        path: 'AboutUs',
        name: 'AboutUs',
        component: () => import('@/views/Config'),
        meta:{
          title: '关于我们'
        }
      },
      {
        path: 'Config',
        name: 'Config',
        component: () => import('@/views/Config'),
        meta:{
          title: ''
        }
      },
    ],
  },
  {
    path: '/mobile',
    component: ()=> import('@/routerViews/ViewMobile'),
    children: [
      {
        path: '',
        name:'MobileIndex',
        component: ()=>import('@/views/mobile/Index'),
        meta:{
          title: '首页'
        }
      },
      {
        path: '',
        name:'MobileAbout',
        component: ()=>import('@/views/mobile/About'),
        meta:{
          title: '关于大赛'
        }
      },
      {
        path: 'news/list',
        name:'MobilenewsList',
        component: ()=>import('@/views/mobile/news/list'),
        meta:{
          title: '新闻动态'
        }
      },
      {
        path: 'news/detail',
        name:'MobilenewsDetail',
        component: () => import('@/views/mobile/news/detail'),
        meta:{
          title: '新闻详情'
        }
      },
      {
        path: '',
        name:'MobileCertificate',
        component: ()=>import('@/views/mobile/Certificate'),
        meta:{
          title: '证书查询'
        }
      },
      {
        path: '',
        name:'MobileContactUs',
        component: ()=>import('@/views/mobile/ContactUs'),
        meta:{
          title: '联系我们'
        }
      },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: to => {
    if (!to.meta.keepAlive) {
      return {
        y: 0
      };
    } else {
      return { x: 0, y: to.meta.savedPosition || 0 };
    }
  },
  routes
})

router.beforeEach((to, from, next) => {
  if (isMobileDevice()) {
    if (!to.path.includes('/mobile'))  { // 确保不是已经要跳转的页面
      next('/mobile'); // 强制跳转到手机版页面
    } else {
      next(); // 如果是目标页面，继续导航
    }
  } else {
    if (to.path.includes('/mobile'))  { 
      next('/');
    } else {
      next();
    }
  }
});
 
function isMobileDevice() {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
}

export default router
